export const MARKETING_CONTACT_US_LINK = 'https://www.hometime.io/contact-us'
